export type ApiFeaturesActionTypes = UpdateApiFeaturesAction;

export const UPDATE_API_FEATURES = "UPDATE_API_FEATURES";
export interface UpdateApiFeaturesAction {
    type: typeof UPDATE_API_FEATURES;
    backendName: string;
    apiFeatures: string[];
}
